import { render, staticRenderFns } from "./DetailWithdrawal.vue?vue&type=template&id=5e257c2a&scoped=true"
import script from "./DetailWithdrawal.vue?vue&type=script&lang=js"
export * from "./DetailWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./DetailWithdrawal.vue?vue&type=style&index=0&id=5e257c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e257c2a",
  null
  
)

export default component.exports